import { Link } from 'react-router-dom';

const NotFound = () => {
    return ( 
        <>
            <div className="container-fluid d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
                <div className="text-center">
                    <div className="bg-white p-5 rounded-3 zis-shadow">
                        <h1 className="display-1 text-danger">404</h1>
                        <h3 className="text-muted mb-4">Page Not Found</h3>
                        <p className="lead text-secondary">  Sorry, the page you're looking for doesn't exist.  <br /> </p>

                        <Link to="/" className="btn btn-primary mt-3">Go Back to Home</Link>
                    </div>
                </div>
            </div>
        </>
    )
}

export default NotFound